const defaultUserLimits: UserLimits = {
    createGroups: true,
    addAdditionalFunds: true,
    joinGroups: true,
}

export interface UserLimitDetail {
    key: keyof UserLimits
    label: string
    description: string
}

const userLimitDetails: Record<keyof UserLimits, UserLimitDetail> = {
    createGroups: {
        key: 'createGroups',
        label: 'Create or recreate groups',
        description: 'Starting new groups and recreating past groups is currently unavailable on your account.',
    },
    addAdditionalFunds: {
        key: 'addAdditionalFunds',
        label: 'Add additional funds',
        description: 'Adding extra funds to an existing group is currently unavailable on your account.',
    },
    joinGroups: {
        key: 'joinGroups',
        label: 'Join groups',
        description: 'Joining groups from invite, welcome, or contribution flows is currently unavailable on your account.',
    },
}

export const parseUserLimits = (data?: Partial<UserLimits> | null): UserLimits => ({
    createGroups: data?.createGroups ?? defaultUserLimits.createGroups,
    addAdditionalFunds: data?.addAdditionalFunds ?? defaultUserLimits.addAdditionalFunds,
    joinGroups: data?.joinGroups ?? defaultUserLimits.joinGroups,
})

export const hasRestrictedUserLimits = (limits: UserLimits) => (
    Object.values(limits).some((isAllowed) => !isAllowed)
)

export const getRestrictedUserLimitDetails = (limits: UserLimits): UserLimitDetail[] => (
    Object.entries(limits).reduce<UserLimitDetail[]>((details, [key, isAllowed]) => {
        if (isAllowed) return details

        const limitKey = key as keyof UserLimits
        return [...details, userLimitDetails[limitKey]]
    }, [])
)
